<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";

  .call-duration {
    align-items: center;
    background-color: rgba(white, 0.15);
    border: utils.in_rem(1px) solid rgba(white, 0.15);
    border-radius: utils.in_rem(40px);
    color: colors.get(textWhite);
    display: inline-flex;
    justify-content: center;
    line-height: 1;
    padding: utils.in_rem(6px) utils.in_rem(8px);
    @include mixins.caption;
  }
</style>

<script>
  import { diallerState } from "../diallerState.svelte";
  let { visible = false } = $props();

  const callDuration = $derived(diallerState.timer.formattedDuration);
</script>

{#if visible && callDuration}
  <div class="call-duration">
    {callDuration}
  </div>
{/if}
